import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the reportHome state domain
 */


const selectClimateMeasurementDomain = (state) =>
  state.get("climateMeasurement", initialState)

/**
 * Other specific selectors
 */

export const makeSelectIsLoadingDimensionsData = () =>
  createSelector(selectClimateMeasurementDomain, (state) =>
    state.get("isLoadingDimensionsData")
  )

export const makeSelectDimensionsData = () => createSelector(selectClimateMeasurementDomain, (state) => state.get("dimensionsData"))

const makeSelectClimateMeasurement = () =>
  createSelector(selectClimateMeasurementDomain, (substate) =>
    substate.toJS()
  )


export default makeSelectClimateMeasurement
export { selectClimateMeasurementDomain }
